import { LitElement, css, html } from "lit";
import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import baseStyles from "../baseStyles.css?raw";

@customElement("bui-icon-list")
export class BuiIconList extends LitElement {
  @property({ type: String }) title: string = "Authenticity Guarantee: ";
  @property({ type: Boolean }) dark: boolean = false;

  static instanceCounter = 0;

  static styles = [
    unsafeCSS(baseStyles),
    css`
      :host {
        animation: fadeIn 0.3s ease-in-out;
        display: flex;
        gap: 8px;
        flex-direction: row;
        --svg-size: 24px;
      }

      :host svg {
        flex-shrink: 0;
        margin-top: 2px;
        width: var(--svg-size, 24px);
        height: var(--svg-size, 24px);
      }

      :host svg path {
        width: 20px;
        height: 20px;
      }

      .dark-mode {
        color: white;

        ::slotted(a) {
          color: white !important;
        }
      }
    `,
  ];

  connectedCallback(): void {
    super.connectedCallback();
    this.id = `bui-icon-list-${BuiIconList.instanceCounter++}`;
  }

  render() {
    return html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12C21.998 13.3827 21.7353 14.6827 21.212 15.9C20.6887 17.1173 19.9763 18.1757 19.075 19.075C18.1737 19.9743 17.1153 20.687 15.9 21.213C14.6847 21.739 13.3847 22.0013 12 22Z"
          fill="${this.dark ? "white" : "black"}"
        />
      </svg>
      <span class="${this.dark ? "dark-mode" : "light-mode"}">
        <strong>${this.title}</strong>
        <slot>All watches are 100% Authentic and certified authentic.</slot>
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bui-icon-list": BuiIconList;
  }
}
